import { render, staticRenderFns } from "./export-link.vue?vue&type=template&id=31c1156a&"
import script from "./export-link.vue?vue&type=script&lang=js&"
export * from "./export-link.vue?vue&type=script&lang=js&"
import style0 from "./_export-link.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports